function CanchasHeader() {
    return (
        <section className="mb-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-3 leading-tight border-l-4 border-red-500 pl-4">
                Las primeras canchas
            </h1>
            <p className="text-base sm:text-lg font-medium text-slate-400 max-w-2xl leading-relaxed">
                Un recorrido cronológico por los escenarios que forjaron la identidad del club más grande,
                desde los espacios públicos hasta la consolidación de nuestra casa actual.
            </p>
        </section>
    );
}

export default CanchasHeader;
